import { createRootRoute, Outlet, useRouter } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { ClerkProvider } from '@clerk/clerk-react';
import { clientEnv } from '@/lib/env';
import { clerkAppearance } from '@/lib/typography';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

function RootComponent() {
  const router = useRouter();
  const app = (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <Helmet>
          <title>Hmonglus</title>
        </Helmet>
        <Outlet />
      </QueryClientProvider>
    </HelmetProvider>
  );
  if (!clientEnv.clerkPublishableKey) return app;
  return (
    <ClerkProvider
      publishableKey={clientEnv.clerkPublishableKey}
      signInUrl="/auth/sign-in"
      signUpUrl="/auth/sign-up"
      appearance={clerkAppearance}
      routerPush={(to) => router.history.push(to)}
      routerReplace={(to) => router.history.replace(to)}
    >
      {app}
    </ClerkProvider>
  );
}

export const Route = createRootRoute({ component: RootComponent });
